import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteCallrailIntegrationUserSettings as DeleteCallrailIntegrationUserSettingsMutation,
    GetSessionUser as GetSessionUserQuery,
} from 'nutshell-graphql-types';

import GET_SESSION_USER from '../../../../core/graphql/queries/get-session-user.graphql';

import DELETE_CALLRAIL_INTEGRATION_USER_SETTINGS from '../mutations/delete-callrail-integration-user-settings.graphql';

export const useDeleteCallrailIntegrationUserSettings = (): {
    deleteCallrailIntegrationUserSettings: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteCallrailIntegrationUserSettings, {loading, error}] = useMutation<
        DeleteCallrailIntegrationUserSettingsMutation,
        Record<any, any>
    >(DELETE_CALLRAIL_INTEGRATION_USER_SETTINGS, {
        update: (proxy, mutationResults) => {
            const loggedInUserCache: GetSessionUserQuery | null | undefined = proxy.readQuery({
                query: GET_SESSION_USER,
            });

            if (
                loggedInUserCache &&
                loggedInUserCache.loggedInUser &&
                loggedInUserCache.loggedInUser.phoneIntegrations &&
                mutationResults.data &&
                mutationResults.data.callRailIntegrationUserSettingsDelete &&
                mutationResults.data.callRailIntegrationUserSettingsDelete.callRailIntegration
            ) {
                const deletedCallRailIntegration =
                    mutationResults.data.callRailIntegrationUserSettingsDelete.callRailIntegration;

                const updatedIntegrations = loggedInUserCache.loggedInUser.phoneIntegrations.map(
                    (integration) => {
                        if (
                            integration.integrationType ===
                            deletedCallRailIntegration.integrationType
                        ) {
                            return deletedCallRailIntegration;
                        }

                        return integration;
                    }
                );

                proxy.writeQuery({
                    query: GET_SESSION_USER,
                    data: {
                        loggedInUser: {
                            ...loggedInUserCache.loggedInUser,
                            phoneIntegrations: updatedIntegrations,
                        },
                    },
                });
            }
        },
    });

    return {
        deleteCallrailIntegrationUserSettings: () => deleteCallrailIntegrationUserSettings(),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
